//@flow
import React, {useState, useEffect} from 'react';
import {makeStyles, Box, Typography, Divider} from '@material-ui/core';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    alignItems: 'center',
    textAlign: 'center',
    // height: 240,
    padding: theme.spacing(4, 0),
  },
  content: {
    maxWidth: 500,
    width: '100%',
    margin: 'auto',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.375rem',
  },
  subtitle: {
    textAlign: 'start',
    fontSize: '0.875rem',
    color: colors.grey700,
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  confirmButton: {
    marginTop: theme.spacing(3),
    width: '100%',
    fontWeight: 600,
    fontSize: '18px',
  },
  selectText: {
    color: '#6A6A7F',
    fontSize: '16px',
    fontWeight: 500,
    textAlign: 'left',
  },
  selectCategory: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  bigSelect: {
    paddingTop: '30px',
  },
}));

type Props = {
  open: boolean,
  onClose: () => void,
  subcategory: string,
  defaultName?: string,
  onSubmit: (name: string) => void,
};

export default function SubcategoryItemModal(props: Props) {
  const {open, onClose, subcategory, onSubmit, defaultName} = props;
  const classes = useStyles();

  const [name, setName] = useState('');

  useEffect(() => {
    if (defaultName) setName(defaultName || '');
  }, [defaultName]);

  const handleSubmit = () => {
    onSubmit(name);
  };

  return (
    <CustomModal open={open} handleCloseModal={onClose}>
      <div className={classes.root}>
        <Box className={classes.content}>
          <Typography align="center" gutterBottom className={classes.title}>
            Sub item de {subcategory}
          </Typography>

          <Divider className={classes.divider} />

          <div className={classes.selectCategory}>
            <Typography className={classes.selectText}>
              Selecciona la subcategoría a la que pertenece
            </Typography>
            <CustomTextField value={subcategory} disabled />

            <CustomTextField
              name="name"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Nombre del sub item"
            />
          </div>
          <CustomButton
            variant="contained"
            fullWidth
            className={classes.confirmButton}
            onClick={handleSubmit}
            disabled={!name}
          >
            {defaultName ? 'Editar sub item' : 'Nueva sub item'}
          </CustomButton>
        </Box>
      </div>
    </CustomModal>
  );
}
